export default __webpack_public_path__ + "static/media/topBun.bbf4b80c.png";